import { Backdrop, CircularProgress, Stack, Typography } from "@mui/material";

export const ProgressCover = ({ open, label = 'Saving' }) => {
    return (
        <Backdrop
            open={open}
            sx={{
                color: "#fff",
                zIndex: (theme) => theme.zIndex.modal + 1,
                backdropFilter: "blur(2px)",
            }}
        >
            <Stack alignItems="center" spacing={2}>
                <CircularProgress
                    thickness={4}
                />
                <Typography variant="h6">{label}</Typography>
            </Stack>
        </Backdrop>
    );
}